/* eslint-disable no-param-reassign */

/**
 * @param {game:Phaser.Game, tutorialBar:boolean} config
 */
export class RequestHelp_Tutorial {
  constructor(config) {
    if (!config.scale) {
      config.scale = 0.65;
    }
    this.rh_levelTutorialGingy; // eslint-disable-line no-unused-expressions
    this.rh_levelTutorialGingy = new G.GingyTutorialBar();
    this.rh_levelTutorialGingy.scale.set(config.scale, config.scale);
    this.renderedBounds = this.rh_levelTutorialGingy.getBounds().clone();

    this.rh_levelTutorialHand = new Phaser.Group(config.game, game.world);
    this.tutorialHandTarget; // eslint-disable-line no-unused-expressions
    const tutorialHandImg = G.makeImage(0, 20, 'tut_hand', 0, this.rh_levelTutorialHand); // Taken from G.DailyIcon
    game.add.tween(tutorialHandImg).to({ x: G.l(20), y: G.l(50) }, 300, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

    this.rh_levelTutorialGingy.hide(null, null, true);
    this.rh_levelTutorialHand.visible = false;
  }

  /**
   * target = {
   *  display: Phaser.Group,
   *  target: Phaser.Group,
   *  offset: Phaser.Point,
   * }
   * @param {Object} target
   * @param {boolean} autoVisOn
   */
  setTarget(target, autoVisOn = false) {
    this.tutorialHandTarget = target;

    if (this.tutorialHandTarget) {
      // The pointing motion
      this.rh_levelTutorialHand.update = () => {
        if (this.tutorialHandTarget) { // incase it destroys itself or something
          const goodPos = game.world.toLocal(this.tutorialHandTarget.target, this.tutorialHandTarget.display);
          goodPos.x += this.tutorialHandTarget.offset.x;
          goodPos.y += this.tutorialHandTarget.offset.y;
          const inPosition = this.rh_levelTutorialHand.position.equals(goodPos);

          if (!inPosition) {
            this.rh_levelTutorialHand.position.set(goodPos.x, goodPos.y);
          } else if (inPosition && autoVisOn && !this.rh_levelTutorialHand.visible) {
            this.rh_levelTutorialHand.visible = true;
          }
          if (autoVisOn) {
            this.rh_levelTutorialHand.visible = true;
          }
        } else {
          this.rh_levelTutorialHand.visible = false;
          this.rh_levelTutorialHand.update = () => {};
        }
      };
    } else {
      this.rh_levelTutorialHand.visible = false;
      this.rh_levelTutorialHand.update = () => {};
    }
  }

  /**
   *
   * @param {string} data
   */
  displayMsg(text) {
    if (text === '') {
      this.rh_levelTutorialGingy.msg.emptyText();
    }
    this.rh_levelTutorialGingy.displayMsg(text);
  }

  destroy() {
    this.rh_levelTutorialGingy.destroy();
    this.rh_levelTutorialHand.update = () => {};
    this.rh_levelTutorialHand.destroy();
  }

  close() {
    this.rh_levelTutorialHand.visible = false;
    this.rh_levelTutorialGingy.hide(() => {
      this.destroy();
    });
  }

  toggleVisibility(vis) {
    if (vis) {
      this.rh_levelTutorialGingy.show();
    } else {
      this.rh_levelTutorialGingy.hide();
    }
    this.rh_levelTutorialHand.visible = vis;
  }

  getLevelWindowSpecificOffset() {
    return (this.rh_levelTutorialHand.height - this.renderedBounds.height) / 2;
  }
}
